import { FC } from 'react';
import { useSingleCourse } from '../../../contexts/SingleCourseProvider';
import { SelfAssessmentContent } from './SelfAssessmentContent/SelfAssessmentContent';
import { ExamContent } from './ExamContent/ExamContent';
import { ProjectContent } from './ProjectContent/ProjectContent';
import { HearingContent } from './HearingContent/HearingContent';
import { StartCourseContent } from './SelfAssessmentContent/StartCourseContent';
import { ResumeCourseContent } from './ResumeCourseContent';

export const StepContent: FC = () => {
  const { course } = useSingleCourse();

  return (
    <>
      {course?.status === 'notStarted' && <StartCourseContent />}
      {course?.isPaused && <ResumeCourseContent />}
      <SelfAssessmentContent />
      <ExamContent />
      <ProjectContent />
      <HearingContent />
    </>
  );
};
